import ExternalDeliveryFileUpdate from '@components/file-update/external-delivery-files';

const ExternalDeliveryFileUpdatePage = () => {
  return <ExternalDeliveryFileUpdate />;
};

export default ExternalDeliveryFileUpdatePage;
